import script from "./milestoneDisplayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./milestoneDisplayer.vue?vue&type=script&setup=true&lang=ts"

import "./milestoneDisplayer.vue?vue&type=style&index=0&id=b55a17f6&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b55a17f6"]])

export default __exports__